import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import { Button, TextField, DialogActions, DialogContent, Grid, Paper } from 'material-ui';
import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';
import { getUserInformation } from '../components/Login/loginService';
import isEmail from 'validator/lib/isEmail';
import { translate } from 'react-i18next';
import i18n from '../services/i18n.js';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '16px',
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main
    }
});

/**
 * Componente modal que permite la carga de datos utilizados en el envío de mail.
 * Si recibe la propiedad "title" la utiliza como título del diálogo. En caso
 * de que no la reciba, muestra el título "Enviar correo".
 * Debe recibir 2 funciones:
 *      onClose: llamada al cerrar el diálogo.
 *      getEmailFrom: función que debe devolver la dirección de correo desde la
 *                  cual enviar el correo.
 */
class SendMailDialog extends React.Component {
    constructor(props) {
        super(props);

        this.currentUser = getUserInformation();

        this.setState({
            to: '',
            from: props.getEmailFrom(),
            subject: '',
            message: '',
            attachments: props.attachments,
            success: false,
            loading: false,
            validEmail: false,
            validSubject: false
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            to: '',
            from: nextProps.getEmailFrom(),
            subject: '',
            message: '',
            attachments: nextProps.attachments,
            success: false,
            loading: false,
            validEmail: false,
            validSubject: false
        });
    }

    handleClose = () => {
        if (!this.state.loading) {
            this.setState({ success: false, loading: true });
        }

        this.sendMail().then(result => {
            if (!result.code) {
                this.setState({ success: true, loading: false });
                this.props.onClose();
            }
            else {
                this.setState({
                    success: false,
                    loading: false
                });
                alert(i18n.t('ALERT.SEND_MAIL_ERROR'));
            }
        });
    };

    sendMail = async () => {
        try {
            const data = {
                to: this.state.to,
                sender: JSON.parse(localStorage.getItem('user')).user_detail.agency_code,
                from: this.state.from,
                subject: this.state.subject,
                body: this.state.message,
                attachments: this.state.attachments
            };

            return await this.props.sendMail(data);
        } catch (error) {

            console.error(error);
            return error;
        }
    };

    handleCancel = () => {
        this.props.onClose(null);
    };

    handleToChange = (data) => {
        this.setState({
            to: data,
            validEmail: isEmail(data)
        });
    };

    handleSubjectChange = (data) => {
        let subjectstr = data.trim();
        this.setState({
            subject: subjectstr,
            validSubject: (subjectstr && subjectstr.length)
        });
    };

    handleMessageChange = (data) => {
        this.setState({ message: data });
    };

    renderDialogTitle = (text, t) => {
        return text && text.length ? text : t('VOUCHER_EMAIL.SEND_MAIL');
    };

    render() {

        const { classes, title, t, ...other } = this.props;

        if (!this.state)
            return '';

        const { loading, validEmail, validSubject } = this.state;

        return (
            <Dialog
                onClose={this.handleClose}
                onEnter={this.handleEnter}
                aria-labelledby="sendemail-dialog"
                fullWidth={true}
                maxWidth='sm'
                {...other}
            >
                <DialogTitle disableTypography={true} id="sendemail-dialog" className={classes.dialogTitle}>
                    {this.renderDialogTitle(title, t)}
                </DialogTitle>
                <DialogContent>
                    <Paper style={{ padding: '12px' }} elevation={0}>
                        <Grid item xs={12}>
                            <TextField
                                label={t('VOUCHER_EMAIL.TO') + ': '}
                                defaultValue=""
                                margin="normal"
                                error={!validEmail}
                                fullWidth={true}
                                autofocus={true}
                                onChange={event => this.handleToChange(event.target.value)}>
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={t('VOUCHER_EMAIL.SUBJECT') + ': '}
                                defaultValue=''
                                margin="normal"
                                error={!validSubject}
                                fullWidth={true}
                                onChange={event => this.handleSubjectChange(event.target.value)}>
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label={t('VOUCHER_EMAIL.MESSAGE') + ': '}
                                defaultValue=''
                                multiline={true}
                                rows="10"
                                margin="normal"
                                fullWidth={true}
                                onChange={event => this.handleMessageChange(event.target.value)}>
                            </TextField>
                        </Grid>
                    </Paper>
                </DialogContent>
                <DialogActions className={classes.root}>
                    <div className={classes.wrapper}>
                        <Button
                            disabled={loading}
                            variant="raised"
                            onClick={this.handleCancel}>
                            {t('VOUCHER_EMAIL.CANCEL_BUTTON')}
                        </Button>
                    </div>
                    <div className={classes.wrapper}>
                        <Button
                            variant="raised"
                            color="primary"
                            disabled={loading || !validEmail || !validSubject}
                            onClick={this.handleClose}>
                            {t('VOUCHER_EMAIL.SEND_BUTTON')}
                        </Button>
                        {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                </DialogActions>
            </Dialog>
        );
    }
}

SendMailDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
};

export default translate('translations')(withStyles(styles)(SendMailDialog));


// WEBPACK FOOTER //
// ./src/ui/SendMailDialog.js